<template>
  <div class="container">
    <div class="center-left">
      <div class="login-box">
        <div class="avatar">
          <img src="#" alt="头像">
        </div>
        <div class="user-desc">
          <span><a href="#">立即登录</a></span>
          <span><a href="#">注册</a></span>
        </div>
      </div>
      <!-- 如果没有登录就显示简介详情，登录后就显示功能按钮 -->
      <div class="desc">
        <div>吃掉那只青蛙</div>
        <div>本网站域名来自《吃掉那只青蛙》，希望我们每个人都克服拖延的坏毛病，本网站打算设计出完美的内容供大家使用。</div>
        <div>{{ currentTime }}</div>
        <div>道阻且长，行则将至</div>
        <div>女子低头不见脚尖，便已具人间绝色。</div>
      </div>
    </div>
    <div class="center-center">
      <span class="center-title">最新文章</span>
      <div v-for="article in articles" :key="article.id" class="article">
        <div class="article-title">
          <a href="#">
            {{ article.title }}
          </a>
        </div>
        <div class="article-content">{{ article.content }}</div>
        <div class="article-info">
          <div>
            <span class="iconfont icon-riqishijian_line"></span>
            <span>{{ article.create_time }}</span>
          </div>
          <div>
            <span class="iconfont icon-tushu"></span>
            <span>1000字</span>
          </div>
          <div>
            <span class="iconfont icon-zuozhe"></span>
            <span>{{ article.user_id }}</span>
          </div>
        </div>
        <div class="article-label">
          <span class="iconfont icon-biaoqian"></span>
          <span class="article-label-span">#{{ article.category }}</span>
        </div>
      </div>
      <div>
        <pagePagination :islastpage="islastpage" :totalpage="totalpage" />
        <!-- <pagePagination /> -->
      </div>
    </div>
    <div class="center-right">
      <div class="search-box">
        <span class="iconfont icon-search"></span>
        <input placeholder="搜索...">
      </div>
      <div class="label-box">
        <div class="label-title noselect">
          <span class="iconfont icon-biaoqian"></span>标签
        </div>
        <div class="label-content">
          <span class="label noselect">#日记</span>
          <span class="label noselect">#随笔记</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { onMounted, onUnmounted, ref } from 'vue'
import request from '@/utils/request'
import getCurrentTime from '@/utils/getCurrentTime'
import pagePagination from '@/components/pagePagination.vue'

export default {
  name: 'HomeCenter',
  components: { pagePagination },
  setup () {
    const articles = ref([])
    let timer = null
    const currentTime = ref(null)
    const totalpage = ref(0)
    const islastpage = ref(false)
    const currentPage = ref(1)
    // 初始化请求文章接口
    const getAllArticle = (page) => {
      request('/article/all', 'get', { nextpage: page }).then(
        response => {
          articles.value = response.data.articles
          totalpage.value = response.data.totalpage
          islastpage.value = response.data.islastpage
          console.log('请求结果', response.data)
        }
      ).catch(err => {
        console.log('请求出错了', err)
      })
    }

    onMounted(() => {
      getAllArticle(currentPage.value)
      timer = setInterval(() => { currentTime.value = getCurrentTime() }, 1000)
    })

    onUnmounted(() => {
      if (timer) {
        clearInterval(timer)
        timer = null
      }
    })

    return {
      getAllArticle,
      articles,
      currentTime,
      islastpage,
      totalpage
    }
  }

}
</script>

<style lang="less" scoped>
.container {
  display: flex;
  gap: 2;
  .center-left {
    flex: 0 0 240px;
    // background-color: rebeccapurple;
    // opacity: 30%;
    height: 80vh;

    @media (max-width: 768px) {
      display: none;
    }
    .login-box {
      // background-color: aqua;
      background-color: rgb(255, 255, 255);
      height: 250px;
      padding: 20px;
      .user-desc {
        width: 100%;
        margin: 20px auto;
      }
    }
    .desc {
      margin: 10px auto;
      padding: 20px;
      // border: 1px solid;
      border-radius: 15px;
      display: flex;
      flex-direction: column;
      gap: 10px;
      background-color: rgb(255, 255, 255);
    }
  }
  .center-center {
    flex: 4;
    padding: 10px 5px;
    .center-title {
      margin-left: 15px;
      // background-color: #999;
      font-size: 18px;
    }
    .article {
      margin: 10px auto;
      padding: 25px;
      // border: 2px solid;
      border-radius: 12px;
      display: flex;
      flex-direction: column;
      gap: 10px;
      background-color: rgb(255, 255, 255);
      .article-title {
        font-size: 26px;
        font-weight: 600;
      }
      .article-content {
        font-size: 14px;
        font-weight: 400;
        // border: 2px dashed rgb(150, 150, 150);
        padding: 15px 10px;
        border-radius: 10px;
        background-color: rgb(240, 240, 240);
      }
      .article-info {
        display: flex;
        column-gap: 40px;
        flex-wrap: wrap;
      }
      .article-label {
        display: flex;
        gap: 20px;
        .article-label-span {
          padding: 0 7px;
          background-color: aquamarine;
          border-radius: 10px;
        }
      }
    }
  }
  .center-right {
    flex: 1;
    margin: 10px 0 0 0;
    @media (max-width: 768px) {
      display: none;
    }
    .search-box {
      display: flex;
      align-items: center;
      border: 1px solid #ddd;
      border-radius: 20px;
      padding: 10px;
      background-color: rgb(255, 255, 255);
      input {
        flex: 1;
        font-size: 14px;
      }
      .iconfont {
        line-height: 1;
        font-size: 18px;
        color: #999
      }
    }
    .label-box {
      margin-top: 10px;
      // background-color: rgb(255, 255, 255);
      padding: 10px 10px;
      height: 300px;
      border-radius: 20px;
      .label-content {
        display: flex;
        column-gap: 10px;
        margin-top: 10px;
        .label {
          background-color: rgb(255, 255, 255);
          padding: 5px;
          border-radius: 7px;
        }
      }
    }
  }
}

</style>>
